import { ChangeDetectionStrategy, Component, ElementRef, Renderer2 } from '@angular/core';

import { environment } from '../environments/environment';


@Component({
  selector: 'app-root',
  templateUrl:'./app.component.html',
  changeDetection: ChangeDetectionStrategy.Default,
})
export class AppComponent {
  constructor(
    private elementRef: ElementRef<HTMLElement>,
    private renderer: Renderer2,
  ) { }

  ngOnInit(): void {
    if (environment.production) {
      this.renderer.removeAttribute(this.elementRef.nativeElement, 'ng-version');
    }
  }
}
